module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [(!_vm.contentLoaderOn) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('p', {
    staticClass: "home-txt",
    staticStyle: {
      "font-family": "LightRubber,Helvetica,Arial,sans-serif"
    }
  }, [_vm._v("\n        Welcome to the Rubbermaid Commercial Smart App. Please select one of the following to view content\n        that suits you.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "home-box1"
  }, [_c('router-link', {
    attrs: {
      "to": "/videos"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "150px"
    }
  }, [_c('img', {
    staticClass: "hbox-img",
    attrs: {
      "src": "static/img/home-page/Videos.png",
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hbox-txt"
  }, [_c('p', {
    staticClass: "htxt"
  }, [_vm._v("VIDEOS")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "home-box2"
  }, [_c('router-link', {
    attrs: {
      "to": "/documents"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "150px"
    }
  }, [_c('img', {
    staticClass: "hbox-img",
    attrs: {
      "src": "static/img/home-page/Product_Use_Manuals.png",
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hbox-txt"
  }, [_c('p', {
    staticClass: "htxt"
  }, [_vm._v("MANUALS")])])])], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.contentLoaderOn) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('vue-content-loading', {
    attrs: {
      "width": 300,
      "height": 100
    }
  }, [_c('rect', {
    attrs: {
      "x": "25%",
      "y": "5",
      "rx": "2",
      "ry": "2",
      "width": "50%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "30%",
      "y": "15",
      "rx": "2",
      "ry": "2",
      "width": "35%",
      "height": "3"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "20%",
      "y": "25",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "60"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "55%",
      "y": "25",
      "rx": "4",
      "ry": "4",
      "width": "23%",
      "height": "60"
    }
  })])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-395ef7a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/homeView.vue
// module id = 2088
// module chunks = 1